import 'react-dates/initialize';
import 'assets/scss/reports.css';
import 'react-dates/lib/css/_datepicker.css';

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Card, CardBody, Col, Row } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-dates';

import ReportDisplay from 'components/reports/ReportDisplay';
import UpgradeToPro from 'components/Banners/reportLimitBanner';
import { isSameDay } from 'utils/date';
import SurveyApi from 'apis/Survey';

import ReportShare from './ReportShare';
import ReportShareModal from './ReportShareModal';

class ReportsListDisplay extends Component {
  constructor() {
    super();

    this.state = {
      focusedInput: null,
      modalToggle: false,
      customSurvey: null,
    };
  }

  onDateChange = ({ startDate, endDate }) => {
    const { changeReportRange } = this.props;
    changeReportRange(startDate, endDate);
  };

  renderDatePresets = () => {
    const { startDate, endDate } = this.props;
    const presets = [
      {
        text: 'This Week',
        start: moment().startOf('week'),
        end: moment().endOf('week'),
      },
      {
        text: 'Last Week',
        start: moment()
          .subtract(1, 'week')
          .startOf('week'),
        end: moment()
          .subtract(1, 'week')
          .endOf('week'),
      },
      {
        text: 'This Month',
        start: moment().startOf('month'),
        end: moment().endOf('month'),
      },
      {
        text: 'Last Month',
        start: moment()
          .subtract(1, 'month')
          .startOf('month'),
        end: moment()
          .subtract(1, 'month')
          .endOf('month'),
      },
    ];

    return (
      <div className="panel">
        {presets.map(({ text, start, end }) => {
          const isSelected =
            isSameDay(start, startDate) && isSameDay(end, endDate);
          return (
            <button
              key={text}
              type="button"
              className={`preset-btn ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                this.onDateChange({ startDate: start, endDate: end });
                this.setState({ focusedInput: null });
              }}
            >
              {text}
            </button>
          );
        })}
      </div>
    );
  };

  reportShareToggle = () => {
    const { modalToggle } = this.state;
    this.setState({ modalToggle: !modalToggle });
  };

  getSurveyName = e => {
    const { customSurveyId } = this.props.match.params;
    const { customSurvey } = this.state;

    if (customSurvey == null) {
      SurveyApi.getSurveyName(customSurveyId).then(({ data }) => {
        this.setState({
          customSurvey: data,
        });
      });
      SurveyApi.verifyReportPassword(customSurveyId, 'Pass Presence').then(
        ({ data }) => {
          if (data) {
            this.setState({ checkvalue: data, is_password: true });
            this.getPassword(e);
          }
        }
      );
    }
    return customSurvey;
  };

  render() {
    const {
      report,
      startDate,
      endDate,
      collapseReport,
      showDateFilter,
      disableShareReport,
      match,
      isPublic,
    } = this.props;

    const { id, customSurveyId } = match.params;
    const { modalToggle, focusedInput } = this.state;

    const $reportDisplay = report.map((question, index) => {
      return (
        <div key={index}>
          <ReportDisplay
            collapseReport={collapseReport}
            question={question}
            isPublic={isPublic}
            dateRange={
              startDate && endDate
                ? {
                    startDate: startDate.unix(),
                    endDate: endDate.unix(),
                  }
                : null
            }
            onDateChange={this.onDateChange}
          />
        </div>
      );
    });

    if (report.length == 0) {
      return (
        <Card className="mt-4">
          <CardBody>No reports to display.</CardBody>
        </Card>
      );
    }
    return (
      <div>
        <ReportShareModal
          modalToggle={modalToggle}
          toggle={this.reportShareToggle}
          id={id}
          customSurveyId={customSurveyId}
        />
        {collapseReport ? (
          <p />
        ) : (
          <Row>
            <Col md={{ size: 6 }}>
              <div
                className="daterange-picker"
                style={{
                  display: showDateFilter ? 'block' : 'none',
                }}
              >
                {' '}
                <b>Filter Dates </b>
                <DateRangePicker
                  small
                  startDateId="startDate"
                  endDateId="endDate"
                  renderCalendarInfo={this.renderDatePresets}
                  startDate={startDate}
                  endDate={endDate}
                  onDatesChange={this.onDateChange}
                  focusedInput={focusedInput}
                  isOutsideRange={dt => dt.isAfter(moment(), 'day')}
                  onFocusChange={focusedInput => {
                    this.setState({ focusedInput });
                  }}
                  showClearDates={startDate || endDate ? true : false}
                />
              </div>
            </Col>
            <ReportShare
              disableShareReport={disableShareReport}
              reportShareToggle={this.reportShareToggle}
              customSurveyId={customSurveyId}
            />
            <Col>
              <UpgradeToPro />
            </Col>
          </Row>
        )}

        <div id="download-report">{$reportDisplay}</div>
      </div>
    );
  }
}

ReportsListDisplay.propTypes = {
  report: PropTypes.array,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  collapseReport: PropTypes.bool,
  showDateFilter: PropTypes.bool,
  disableShareReport: PropTypes.func,
  match: PropTypes.object,
  isPublic: PropTypes.bool,
  changeReportRange: PropTypes.func,
  fetchReport: PropTypes.func,
};

export default withRouter(ReportsListDisplay);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsListDisplay.js